import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import state from './state'
import getters from './getters'
import mutations from './mutations'
Vue.use(Vuex)
export default new Vuex.Store({
  strict: false,
  state: state,
  getters,
  mutations: mutations,
  modules: {
    cart,
  },
})
